// eslint-disable-next-line
import React from 'react';
import './App.scss';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import RouterSwitch from './AppRouter';
import Routing from '@nal/components/Routing/Routing';
import boot from 'app/redux/boot';
import { ThemeProvider, unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
const theme = unstable_createMuiStrictModeTheme();

function App() {
    return (
        <ThemeProvider theme={theme}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Provider store={store}>
                    <Routing />
                    <RouterSwitch />
                </Provider>
            </MuiPickersUtilsProvider>
        </ThemeProvider>
    );
}

export default App;

boot().then(() => App());
